import axios from 'axios'
import {
  randRange
} from '@packages/utils'

export let options = {
  httpRequest: {
    /**
     * 七牛上传配置URL
     * @param {*} type
     */
    qiniuTokenUrl(type) {
      return `/v1.0/common/${type}/qiniu_token`
    },
    /**
     * 获取七牛上传配置
     * http://192.168.1.135:9001/eam/swagger-ui.html#!/HomeController/getQiniuTokenUsingGET
     * @param {*} type 1-图片
     */
    getServerConfig(type = 1) {
      return axios({
        url: this.qiniuTokenUrl(type),
        method: 'GET',
        responseType: 'json'
      }).then(data => {
        return {
          domain: data.domainUrl,
          zoneUrl: this.getZoneUrl(data.qiniuZone.upUrls),
          token: data.token
        }
      })
    },
    /**
     * 取七牛上传地址
     * @param {*} qiniuZone
     */
    getZoneUrl(qiniuZone) {
      if (Array.isArray(qiniuZone)) {
        let len = qiniuZone.length
        return qiniuZone[randRange(0, len - 1)]
      }
      return String(qiniuZone)
    }
  }
}

export const merge = opts => {
  if (opts.httpRequest !== false) {
    options.httpRequest = Object.assign(options.httpRequest, opts.httpRequest)
  }
}



// WEBPACK FOOTER //
// ./src/packages/third/qiniu/options.js